import { IntlShape } from "react-intl";
import { ITextField } from "cayo.ui";
import { CustomSchedule } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";
import { nameofFactory } from "@cayo/shared/utils/object";
import { formComponentTypes } from "../Form/renderers/form-renderers";

const customScheduleNames = nameofFactory<CustomSchedule>();

const customForm = (intl: IntlShape, schedule?: CustomSchedule) => {
  return {
    title: intl.formatMessage(messages.customSchedule),
    style: { width: "100%" },
    items: [
      {
        type: "textfield" as formComponentTypes,
        required: true,
        disabled: schedule?.readОnly,
        autoFocus: true,
        name: customScheduleNames("expression"),
        value: schedule?.expression,
        tooltip: intl.formatMessage(messages.cronDescription),
        label: "Expression",
      } as ITextField,
    ] as IFormField[],
  };
};

export default customForm;
